<template>
  <!-- 宽图 -->
  <div>
    <Upload
      action=""
      :before-upload="beforeUpload"
      accept=".jpeg,.png,.jpg"
      limit="1"
    >
      <img v-if="oldUrlll.length > 0" :src="oldUrlll" class="imagesty" />
      <Button
        type="ghost"
        icon="ios-cloud-upload-outline"
        v-if="oldUrlll.length == 0"
        >{{ title }}</Button
      >
    </Upload>
  </div>
</template>
<script>
// import OSS from "ali-oss"; // 引入oss.js文件
const OSS = require("ali-oss");
import { getSTS } from "../../api/api";

var ossClient = null;
export default {
  name: "VideoUpload",
  props: {
    // 图片属性数组
    // eslint-disable-next-line vue/require-default-prop
    value: Array,
    styleAvatar: {
      default: true,
      type: Boolean,
    },
    // 最大上传图片数量
    maxCount: {
      type: Number,
      default: 5,
    },
    uploadPath: {
      type: String,
      default: "/test/",
    },
    title: {
      type: String,
      default: "",
    },
    levelFlag: {
      type: Number,
      default: 0,
    },
    oldUrl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      hideUploadEdit: false,
      dialogVisible: false,
      dialogImageUrl: null,
      oldUrlll: this.oldUrl,
    };
  },
  watch: {
    oldUrl(newVal) {
      console.log("----------" + newVal);
      this.oldUrlll = process.env.OSS + newVal; // 当 oldUrl 发生变化时，更新 oldUrlll
      console.log("----------" + this.oldUrlll);

    },
  },

  computed: {
    fileList() {
      const fileList = [];
      for (let i = 0; i < this.value.length; i++) {
        if (this.value[i].substring(0, 4) !== "http") {
          fileList.push({ url: this.$columns.imgPath + this.value[i] });
        } else {
          fileList.push({ url: this.value[i] });
        }
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.hideUploadEdit = fileList.length >= this.maxCount;
      return fileList;
    },
  },
  methods: {
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpg";
      const extension2 = testmsg === "jpeg";
      const extension3 = testmsg === "png";
      const extension4 = testmsg === "gif";
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$Message.info("请上传 jpg png jpeg gif 格式类型的图片!");
        return false;
      }

      this.httpRequest(file);
      return false;
    },
    httpRequest(file2) {
      getSTS().then((ress) => {
        ossClient = new OSS({
          region: "oss-cn-zhangjiakou",
          accessKeyId: ress.data.AccessKeyId,
          accessKeySecret: ress.data.AccessKeySecret,
          bucket: "youyiweb",
          stsToken: ress.data.SecurityToken,
          refreshSTSTokenInterval: 3000,
          // stsToken
        });
        let that = this;
        const file = file2; // 文件信息
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        month = month > 9 ? month : "0" + month;
        strDate = strDate > 9 ? strDate : "0" + strDate;
        hour = hour > 9 ? hour : "0" + hour;
        minute = minute > 9 ? minute : "0" + minute;
        second = second > 9 ? second : "0" + second;
        var newdata = year + month + strDate + hour + minute + second;
        var name = "";

        name = newdata + file.name;

        const fileName = "nodeimg/" + name;
        ossClient
          .put(fileName, file2, {
            // 'ContentType': 'image/jpeg'
          })
          .then(({ res, url, name }) => {
            console.log(`阿里云OSS上传图片成功`);
            that.oldUrlll = process.env.OSS  + name;
            this.$emit("update:image", name);
          })
          .catch((err) => {
            console.log(`阿里云OSS上传图片失败回调`, err);
          });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}

.avatar-uploader-y .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-y .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon-y {
  font-size: 28px;
  color: #8c939d;
  width: 208px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.imagesty {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
